import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../components/HomePage.vue";
import UserDashboard from "../components/UserDashboard.vue";
import CoffeeTracker from "../components/CoffeeTracker.vue"; // Import the CoffeeTracker component
import SexTracker from "../components/SexTracker.vue";
import WeightTracker from "../components/WeightTracker.vue";
import ToiletTracker from "../components/ToiletTracker.vue";
import MyData from "../components/MyData.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/dashboard",
    name: "UserDashboard",
    component: UserDashboard,
  },
  {
    path: "/coffee-tracker", // New route for the coffee tracker
    name: "CoffeeTracker",
    component: CoffeeTracker,
  },
  {
    path: "/sex-tracker", // New route for the coffee tracker
    name: "SexTracker",
    component: SexTracker,
  },
  {
    path: "/weight-tracker", // New route for the coffee tracker
    name: "WeightTracker",
    component: WeightTracker,
  },
  {
    path: "/toilet-tracker", // New route for the coffee tracker
    name: "ToiletTracker",
    component: ToiletTracker,
  },
  {
    path: "/my-data",
    name: "MyData",
    component: MyData,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
